export const EXIT_NAV_DELAY = 1000;
export const EXIT_PAGE_DURATION = 450;

export default {
  EXIT_NAV_DELAY,
  EXIT_PAGE_DURATION,
};
